import { Component } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { AccountService } from '../../services/account.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: [
        `
    @media only screen and (max-width: 768px) {
  /* Your CSS styles for mobile devices */
  .header .logo {
        display: block;
        width:60px;
    }
    @media (max-width: 480px) {
            .fs-1024 {
            font-size: clamp(14px, 1.5vw, 20px);
            }
            .affiliate-select {
                min-width: 100px;
                max-width: 100px;
            }
            .m-view{
                display:none;
            }
        }
    .header .logo .logo-fold {
    display: none;
    margin-left:10px;

}
}
        `
    ]
})

export class HeaderComponent {
    greeting: string = '';
    searchVisible: boolean = false;
    quickViewVisible: boolean = false;
    isFolded: boolean;
    isExpand: boolean;
    currentUser: any;

    constructor(private themeService: ThemeConstantService,
        public service: AccountService
    ) {
        if (localStorage.getItem('currentUser')) {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        }
    }

    ngOnInit(): void {
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
        this.setGreeting();
    }

    toggleFold() {
        this.isFolded = !this.isFolded;
        this.themeService.toggleFold(this.isFolded);
    }

    toggleExpand() {
        this.isFolded = false;
        this.isExpand = !this.isExpand;
        this.themeService.toggleExpand(this.isExpand);
        this.themeService.toggleFold(this.isFolded);
    }

    searchToggle(): void {
        this.searchVisible = !this.searchVisible;
    }

    quickViewToggle(): void {
        this.quickViewVisible = !this.quickViewVisible;
    }

    notificationList = [
        {
            title: 'You received a new message',
            time: '8 min',
            icon: 'mail',
            color: 'ant-avatar-' + 'blue'
        },
        {
            title: 'New user registered',
            time: '7 hours',
            icon: 'user-add',
            color: 'ant-avatar-' + 'cyan'
        },
        {
            title: 'System Alert',
            time: '8 hours',
            icon: 'warning',
            color: 'ant-avatar-' + 'red'
        },
        {
            title: 'You have a new update',
            time: '2 days',
            icon: 'sync',
            color: 'ant-avatar-' + 'gold'
        }
    ];
    setGreeting() {
        const currentHour = new Date().getHours();

        if (currentHour < 12) {
            this.greeting = 'Good Morning ☀️';
        } else if (currentHour < 17) {
            this.greeting = 'Good Afternoon 🌤️';
        } else {
            this.greeting = 'Good Evening 🌙';
        }
    }
}
